import { jsx as _jsx } from "react/jsx-runtime";
import { useBrandedVisitorGate } from '#pplx/frontend/apps/ask/hooks/branded-visitor-gate-hooks/useBrandedVisitorGate.js';
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { MenuItemUpsell } from '#pplx/frontend/apps/ask/menus/MenuItemUpsell.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import React, { memo, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const SourcesMenuUpsellMenuItem = memo(function SourcesMenuUpsellMenuItem() {
    const openPaywallUpsell = usePaywallUpsell();
    const { $t } = useIntl();
    const isUserLoggedIn = useIsUserLoggedIn();
    const { openVisitorLoginUpsell } = useBrandedVisitorGate({
        enabled: !isUserLoggedIn,
    });
    const handleSelect = useCallback(() => {
        if (!isUserLoggedIn) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('upsell', 'sources');
            openVisitorLoginUpsell({
                title: $t({
                    defaultMessage: 'Sign in to connect more sources',
                    description: 'Login upsell title when a visitor tries to access more sources',
                    id: '5321b7df0f',
                }),
                description: $t({
                    defaultMessage: 'Access more sources to enhance your searches with Perplexity',
                    description: 'Login upsell description when a visitor tries to access more sources',
                    id: '2becaa4b6b',
                }),
                origin: ModalOrigin.SOURCES_VIEW_MORE,
                overrideRedirectUrl: currentUrl.toString(),
            });
            return;
        }
        openPaywallUpsell({
            pitchMessage: {
                title: $t({
                    defaultMessage: 'Upgrade to connect more sources',
                    description: 'Paywall upsell title when a subscribed user tries to access more sources',
                    id: 'dab42202cc',
                }),
                description: $t({
                    defaultMessage: 'With Perplexity Pro, connect more sources to enhance your searches',
                    description: 'Paywall upsell description when a subscribed user tries to access more sources',
                    id: '361af5b46d',
                }),
            },
            origin: ModalOrigin.SOURCES_VIEW_MORE,
        });
    }, [$t, isUserLoggedIn, openVisitorLoginUpsell, openPaywallUpsell]);
    return (_jsx(MenuItemUpsell, { onSelect: handleSelect, children: _jsx(FormattedMessage, { defaultMessage: "Upgrade to connect more sources", description: "Menu item label prompting users to upgrade for more sources", id: "f672acab9d" }) }));
});
//# sourceMappingURL=SourcesMenuUpsellMenuItem.js.map